import { memo } from 'react'
import { Input } from '@campgladiator/cgui-core.atoms.input'
import { PinInput } from '@campgladiator/cgui-core.atoms.pin-input'
import { FormPart } from '@campgladiator/cgui-core.molecules.form-part'
import { PinOrPasswordInputProps } from '../../Login.d'

const PinOrPasswordInput = ({
  inputType,
  pinLength,
  invalid,
  errorMsg,
  valueChangeHandler,
}: PinOrPasswordInputProps) => (
  <FormPart
    forId={inputType === 'pin' ? 'pin' : 'password'}
    label={inputType === 'pin' ? 'PIN Number' : 'Password'}
    errorMsg={errorMsg}
  >
    {inputType === 'pin' ? (
      <PinInput
        id="pin"
        name="pin"
        autoFocus
        numberOfDigits={pinLength}
        invalid={invalid}
        onPinChange={(value) => valueChangeHandler(value)}
      />
    ) : (
      <Input
        id="password"
        name="password"
        autoFocus
        type="password"
        invalid={invalid}
        onInputChange={(value) => valueChangeHandler(value)}
        placeholder="Enter your password here"
      />
    )}
  </FormPart>
)

export default memo(PinOrPasswordInput)
